

const DiscountBanner = ()=> {
    return (
        <div>Discount banner</div>
    )
}

export default DiscountBanner;